export default __webpack_public_path__ + "420a523ffdb5e3eed68247e604c6f4c1.png";